import { render } from "./Medico_EspeMedi.vue?vue&type=template&id=fc54e6e2"
import script from "./Medico_EspeMedi.vue?vue&type=script&lang=js"
export * from "./Medico_EspeMedi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__